import { ActiveBundlePageTypeKeys, TimelineChronologyPage } from '@/store';

/**
 * Sorts pages by bundle page number depending on activeBundlePageType.
 * Pages with null or undefined numbers are ignored.
 * Returns a new sorted array, does not mutate the input.
 */
export function sortPagesByBundleType(
  pages: TimelineChronologyPage[],
  activeBundlePageType: ActiveBundlePageTypeKeys
): TimelineChronologyPage[] {
  if (!Array.isArray(pages)) return [];
  const key = activeBundlePageType === 'light' ? 'lightBundlePageNumber' : 'fullBundlePageNumber';
  return pages
    .filter((page) => typeof page[key] === 'number' && page[key] !== null)
    .sort((a, b) => (a[key] as number) - (b[key] as number));
}
